import React from 'react';
import { FileText, ExternalLink } from 'lucide-react';
import './ReportsNative.css';

/**
 * Readable file link cell (per revenue-night-audits.html): orange badge,
 * mono filename, type tag, external-link affordance.
 *
 * Props:
 *   name     display filename (required)
 *   href     opens in a new tab when provided
 *   onClick  alternative click handler (renders a <button>)
 *   type     short type tag, e.g. 'PDF' (default derived from extension)
 *   icon     override badge icon node
 */
export function FileLink({ name, href, onClick, type, icon, className, title }) {
  const ext = type || (name && name.includes('.') ? name.split('.').pop().toUpperCase().slice(0, 4) : null);
  const inner = (
    <>
      <span className="rn-file-badge">{icon || <FileText />}</span>
      <span className="rn-file-name" title={title || name}>
        {name}
      </span>
      {ext && <span className="rn-file-type">{ext}</span>}
      <ExternalLink className="rn-file-ext" />
    </>
  );
  const cls = `rn-file-link${className ? ` ${className}` : ''}`;
  if (href) {
    return (
      <a className={cls} href={href} target="_blank" rel="noopener noreferrer" onClick={onClick}>
        {inner}
      </a>
    );
  }
  return (
    <button type="button" className={cls} onClick={onClick}>
      {inner}
    </button>
  );
}

export default FileLink;
